import styled from 'styled-components';
import colors from '../../theme/constants/colors';
import {StyledProps} from './typings';
import Typography from '../../theme/typography';

export const StyledSwitchContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
`;

export const StyledSwitchTitleContainer = styled.div`
  display: flex;
  flex-direction: column;

  h4 {
    ${Typography.Subtitle1}
  }

  p {
    ${Typography.Body3}
  }
`;

export const StyledSwitchWrapper = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;

  > span {
    ${Typography.Body2}
    margin-left: 10px;
  }
`;

export const StyledSwitch = styled.label<StyledProps>`
  position: relative;
  display: inline-block;
  width: 40px;
  height: 21px;
  margin: 0;
  ${(props) => props.$disabled && 'pointer-events: none;'}

  > input {
    opacity: 0;
    width: 0;
    height: 0;

    &:checked + span {
      background-color: ${(props) => (props.$disabled ? colors.grey25 : colors.red25)};

      &::before {
        transform: translateX(19px);
        background-color: ${(props) => (props.$disabled ? colors.grey100 : colors.red100)};
      }
    }

    &:focus + span {
      box-shadow: none;
    }
  }

  > span {
    position: absolute;
    border-radius: 15px;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    height: 14px;
    background-color: ${(props) => (props.$disabled ? colors.grey25 : colors.grey100)};
    transition: 0.3s;

    &::before {
      position: absolute;
      content: '';
      border-radius: 50%;
      height: 21px;
      width: 21px;
      left: 0;
      bottom: -3px;
      background-color: ${colors.white};
      transition: 0.3s;
      box-shadow: 1px 1px 4px 0 rgba(255, 23, 73, 0.27), 1px 5px 7px 0px rgba(0, 0, 0, 0.05);
      border: 1px solid rgba(0, 0, 0, 0.1);
    }
  }
`;
